import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RestService } from './rest.service';
import { Model } from '../Models/model';

@Injectable({
  providedIn: 'root'
})
export class CucumberService {

  constructor(private rest: RestService) { }
  
  public getItemsByStep(model_id: string): Observable<Model[]>{
    return this.rest.get('cucumbers',model_id);
  }
  public addNewInSuite(suite_id,model):Observable<any>{
    // var datamodel=this.cucumberData(model);
    var data =this.dataCreatorsuite(suite_id,model);
  return this.rest.put('addcucumbersSuite',data); 
  }
  public addNewInSuitedb2(suite_id,model):Observable<any>{
    var data =this.dataCreatorsuite(suite_id,model);
  return this.rest.put('addcucumbersSuitedb2',data); 
  }
  public addNewInFeature(feature,model):Observable<any>{
    // var datamodel=this.cucumberData(model);
    var data =this.dataCreatorfeature(feature,model);
  return this.rest.put('addcucumbersFeature',data); 
  }
  public addNewInScenario(scenario_id,model):Observable<any>{
    // var datamodel=this.cucumberData(model);
    var data =this.dataCreatorscenario(scenario_id,model);
  return this.rest.put('addcucumbersScenario',data); 
  }
  public getSuiteCucumber(suite_id): Observable<any> {
    return this.rest.get('getcucmberSuite', suite_id)
  }
  public getSuiteCucumberdb2(suite_id): Observable<any> {
    return this.rest.get('getcucmberSuitedb2', suite_id)
  }
  public getFeatureCucumber(feature_id): Observable<any> {
    return this.rest.get('getcucmberFeature', feature_id)
  }
  public getScenarioCucumber(scenario_id): Observable<any> {
    return this.rest.get('getcucmberScenario', scenario_id)
  }

  dataCreatorsuite(_id,datamodel){
    return {
      suite: {_id:_id},
      cucumbers : datamodel
    };
  }
  dataCreatorfeature(_id,datamodel){
    return {
      feature: {_id:_id},
      cucumbers : datamodel
    };
  }
  dataCreatorscenario(_id,datamodel){
    return {
      scenario: {_id:_id},
      cucumbers : datamodel
    };
  }
  cucumberData(model){
    var al=[];
      for(var x = 0;x<model.length;x++)
        al.push({
          model:[model[x]._id],
          type:model[x]._type,
          seq_no:model[x]['seq_no']
        });
      return al;
    }
    delete(parent_id,cucumber_id){
      let model={
        cucumber:{
 _id:cucumber_id,
 model:parent_id
        }
      }
   return   this.rest.post("deleteCucumber",model)

    }
}
